import FlutterwaveLogo from "./flutterwave-logo.svg";
import Form from "./form.svg";
import PayButton from "./paybutton.svg";
import Link from "./link.svg";
import Status from "./status.svg";
import Donate from "./donate.svg";
import card from "./Card_2.svg";
import Paypal from "./Paypal.svg";
import Momo from "./Momo.svg";
import Migo from "./migo_2.svg";
import Pwbt from "./PWBT-GS.svg";
import Barter from "./Barter.svg";
import Paga from "./Paga.svg";
import Qr from "./QR_2.svg";
import Ussd from "./USSD.svg";
import Bank from "./Bank.svg";
import Voucher from "./Discount.svg";
import Payattitude from "./Payattitude.svg";
export default {
	logo: FlutterwaveLogo,
	form: Form,
	btn: PayButton,
	link: Link,
	status: Status,
	donate: Donate,
	card,
	Paypal,
	Momo,
	Migo,
	Pwbt,
	Barter,
	Paga,
	Qr,
	Ussd,
	Bank,
	Voucher,
	Payattitude,
};
